// extracted by mini-css-extract-plugin
export default {"main":"notFound_main__amHMW","error_container":"notFound_error_container__XjzAP","errorActions":"notFound_errorActions__gvNJF"};